// @flow

import MenuListModel from './menu-list';
import { default as MenuListTemplate } from './templates/index.html';

export const COMPONENTS_MENU_LIST_NAME = 'menu-list';

export const COMPONENTS_MENU_LIST_ENTITIES = [
	{
		name: COMPONENTS_MENU_LIST_NAME,
		entity: MenuListModel,
		template: MenuListTemplate,
	},
];